"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PointConstraint_dragOrigin, _PointConstraint_point, _PointConstraint_radius, _PointConstraint_rotation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointConstraint = void 0;
const DragConstraintsHelper_1 = require("./DragConstraintsHelper");
const InteractionData_1 = require("../InteractionData");
const gl_matrix_1 = require("gl-matrix");
/**
 * The point constraint is used for dragging and allows to specify the position where an object can be dragged to.
 * The radius defines in which distance this constraint is being considered to be chosen from the constraints defined.
 * The transformation and optional rotation of this constraint get applied to the node if it is the constraint with the closest distance to the ray that was used for the drag event.
 * As this is a difficult topic, please visit our [help desk section on interactions](https://help.shapediver.com/doc/interactions-part-1) where we go through the process of setting everything up with examples.
 */
class PointConstraint {
    // #endregion Properties (4)
    // #region Constructors (1)
    /**
     * @param _point the point
     * @param _radius the radius in which the point is considered
     * @param _rotation the rotation in [axis-angle representation](https://en.wikipedia.org/wiki/Axis%E2%80%93angle_representation) that is applied to the node if the drag contraint becomes active
     */
    constructor(_point, _radius = 0, _rotation) {
        // #region Properties (4)
        _PointConstraint_dragOrigin.set(this, void 0);
        _PointConstraint_point.set(this, void 0);
        _PointConstraint_radius.set(this, 0);
        _PointConstraint_rotation.set(this, void 0);
        __classPrivateFieldSet(this, _PointConstraint_point, _point, "f");
        __classPrivateFieldSet(this, _PointConstraint_radius, _radius, "f");
        __classPrivateFieldSet(this, _PointConstraint_rotation, _rotation || { axis: gl_matrix_1.vec3.fromValues(0, 0, 1), angle: 0 }, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (3)
    get point() {
        return __classPrivateFieldGet(this, _PointConstraint_point, "f");
    }
    get radius() {
        return __classPrivateFieldGet(this, _PointConstraint_radius, "f");
    }
    get rotation() {
        return __classPrivateFieldGet(this, _PointConstraint_rotation, "f");
    }
    // #endregion Public Getters And Setters (3)
    // #region Public Methods (2)
    intersect(viewport, node, ray) {
        const closestPoint = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _PointConstraint_point, "f"), ray.origin);
        const directionDistance = gl_matrix_1.vec3.dot(closestPoint, ray.direction);
        if (directionDistance < 0) {
            gl_matrix_1.vec3.copy(closestPoint, ray.origin);
        }
        else {
            gl_matrix_1.vec3.multiply(closestPoint, gl_matrix_1.vec3.copy(closestPoint, ray.direction), gl_matrix_1.vec3.fromValues(directionDistance, directionDistance, directionDistance));
            gl_matrix_1.vec3.add(closestPoint, closestPoint, ray.origin);
        }
        const distance = gl_matrix_1.vec3.distance(closestPoint, __classPrivateFieldGet(this, _PointConstraint_point, "f"));
        if (distance < __classPrivateFieldGet(this, _PointConstraint_radius, "f")) {
            const { matrix, dragAnchor } = (0, DragConstraintsHelper_1.calculateDragMatrix)(node, __classPrivateFieldGet(this, _PointConstraint_point, "f"), __classPrivateFieldGet(this, _PointConstraint_rotation, "f"), __classPrivateFieldGet(this, _PointConstraint_dragOrigin, "f"), closestPoint);
            return { distance, transformation: matrix, dragAnchor };
        }
        return;
    }
    setup(viewport, node, ray, intersection, previousDragMatrix) {
        const data = node.data.find(d => d instanceof InteractionData_1.InteractionData);
        let invertedPreviousDragMatrix = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), previousDragMatrix);
        if (!invertedPreviousDragMatrix)
            invertedPreviousDragMatrix = gl_matrix_1.mat4.create();
        __classPrivateFieldSet(this, _PointConstraint_dragOrigin, data && data.dragOrigin ? gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), data.dragOrigin, node.worldMatrix) : gl_matrix_1.vec3.transformMat4(gl_matrix_1.vec3.create(), intersection.point, invertedPreviousDragMatrix), "f");
        return this.intersect(viewport, node, ray);
    }
}
exports.PointConstraint = PointConstraint;
_PointConstraint_dragOrigin = new WeakMap(), _PointConstraint_point = new WeakMap(), _PointConstraint_radius = new WeakMap(), _PointConstraint_rotation = new WeakMap();
//# sourceMappingURL=PointConstraint.js.map